import Schedule from "../../../../src/components/Schedule";
import React from 'react';
export default {
  Schedule,
  React
};